// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1x2rS","backBtn":"styles_backBtn__3s4Rb"};